import { Injectable } from "@angular/core";
import { combineLatest, map, Observable } from "rxjs";
import { QuickAction } from "../models/quick-action.model";
import { TranslateService } from "@ngx-translate/core";
import { SuiteCrmAssignmentGroupIdentity } from "../models/suite-crm-assignment-group-identity.model";

@Injectable()
export class UtilService {
  constructor(private translateService: TranslateService) {}

  public getQuickAction(
    applicationId: string,
    displayKey: string,
    icon: string,
    displayPrefixKey: string = undefined,
  ): Observable<QuickAction> {
    const displayNameDe$ = this.translateService.currentLoader.getTranslation("de");
    const displayNameEn$ = this.translateService.currentLoader.getTranslation("en");

    return combineLatest([displayNameDe$, displayNameEn$]).pipe(
      map(([de, en]) => {
        const quickAction: QuickAction = {
          applicationId: applicationId,
          userId: undefined,
          displayNameDe: displayPrefixKey
            ? this.resolve(displayPrefixKey, de) + " " + this.resolve(displayKey, de)
            : this.resolve(displayKey, de),
          displayNameEn: displayPrefixKey
            ? this.resolve(displayPrefixKey, en) + " " + this.resolve(displayKey, en)
            : this.resolve(displayKey, en),
          icon,
          link: window.location.href,
          index: undefined,
          disabled: false,
        };
        return quickAction;
      }),
    );
  }

  private resolve(stringPath, baseObject): any {
    return stringPath.split(".").reduce((p, q) => {
      return p ? p[q] : null;
    }, baseObject || self);
  }

  contactIsAssignedIdentities(
    agis: SuiteCrmAssignmentGroupIdentity[],
    identities: string[],
  ): boolean {
    for (let i = 0; i < agis?.length; i++) {
      if (this.gemIdIncludesIdentities(agis[i].groupGemId, identities)) {
        return true;
      }
    }
    return false;
  }

  private gemIdIncludesIdentities(gemId: string, identities: string[]): boolean {
    for (let i = 0; i < identities.length; i++) {
      if (this.gemIdIncludesIdentity(gemId, identities[i])) {
        return true;
      }
    }
    return false;
  }

  private gemIdIncludesIdentity(gemId: string, identity: string): boolean {
    const identityArr: string[] = identity.split(".");
    const groupGemIdArr: string[] = gemId.split(".");
    for (let i = 0; i < identityArr.length; i++) {
      if (identityArr[i] === "*") {
        continue;
      }
      if (identityArr[i] !== groupGemIdArr[i]) {
        return false;
      }
    }
    return true;
  }
}
